import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import ModalDialog from '../modal-dialog/ModalDialog'

const TITLE = 'ביטול הסכמה לדיוור'
const EXPLANATION = 'ביטול הסימון יבטל את הסכמת הנמען לקבלת דיוור שיווקי בכתובת הזאת.'
const CONFIRM_LABEL = 'ביטול הסכמה'
const DECLINE_LABEL = 'חזרה'

export default function MarketingWithdrawalDialog({
    open = false,
    detail = null,
    onConfirm,
    onDecline,
}) {
    const commands = [
        {
            label: DECLINE_LABEL,
            color: 'secondary',
            testId: 'marketing-withdrawal-decline',
            onClick: () => onDecline?.(),
        },
        {
            label: CONFIRM_LABEL,
            testId: 'marketing-withdrawal-confirm',
            position: 'end',
            onClick: () => onConfirm?.(),
        },
    ]

    return (
        <ModalDialog
            open={open}
            title={TITLE}
            commands={commands}
            onClose={onDecline}
        >
            <MDBox
                display="flex"
                flexDirection="column"
                gap="0.75rem"
                data-testid="marketing-withdrawal-dialog"
            >
                <MDTypography variant="body2">{EXPLANATION}</MDTypography>

                {detail?.value != null && (
                    <MDTypography variant="body2" fontWeight="medium">
                        {detail.value}
                    </MDTypography>
                )}
            </MDBox>
        </ModalDialog>
    )
}
